import React, { useCallback, useEffect, useState } from "react";
import MFNavHeader from "../../../components/import/mfnav/MFNavHeader.jsx";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import MFNavConfig from "./MFNavConfig.jsx";
import axios from "axios";
import { errorNotify, successNotify } from "../../../Services/Notification.js";
import { format } from "date-fns";
import ImportSchemePopup from "../../../components/import/mutualFund/ImportSchemePopup.jsx";

const getMFNavDataAPIURL = `${process.env.REACT_APP_API_URL}api/service-tracker/mf-nav/`;
const reloadAPIURL = `${process.env.REACT_APP_API_URL}api/import-mf-nav/`;
const MFNav = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();
  const [isImportPopupOpen, setIsImportPopupOpen] = useState(false);

  const triggerRerender = () => {
    setRenderKey((prev) => prev + 1);
  };
  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const getMFNavData = async () => {
    setLoading(true);
    try {
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        const payload = {
          start_date: filter?.bookclose_recorddate,
          end_date: filter?.nse_exdate,
          status: "All",
          sgmt: "All",
          src: "All",
        };
        const res = await axios.post(getMFNavDataAPIURL, payload, { headers });

        if (!res.data.error) {
          const formatedDateData = res.data.data
            ?.sort((a, b) => new Date(b.date) - new Date(a.date))
            ?.map((item) => ({
              ...item,
              date: item.date,
              status: item?.corp_action?.operation_status,
              op_cnt: item?.corp_action?.op_cnt,
              ip_cnt: item?.corp_action?.ip_cnt,
              file_name: item?.corp_action?.file_name,
            }));
          setData(formatedDateData);
          setLoading(false);
        } else {
          errorNotify(res.data.message);
          setLoading(false);
        }
      } else if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select end date");
      } else if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        errorNotify("Please select start date");
      } else if (!filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select start and end date");
      }
      setLoading(false);
    } catch (err) {
      errorNotify("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      getMFNavData();
    } else if (!filter) {
      setData([]);
    }
  }, [filter?.bookclose_recorddate, filter?.nse_exdate, renderKey]);

  const handleReload = async (date) => {
    try {
      if (date) {
        const payload = {
          start_date: date,
          end_date: date,
        };
        const res = await axios.post(reloadAPIURL, payload, { headers });
        if (res.data.result.success) {
          successNotify(res.data.result.message);
          triggerRerender();
          return true;
        } else {
          errorNotify(res.data.result.message);
          return true;
        }
      }
    } catch (err) {
      errorNotify("Something went wrong");
      triggerRerender();
      return true;
    }
  };

  const buttonConfig = {
    handleReload: handleReload,
  };

  const breadcrumbs = ["Home", "Import", "Mutual Fund NAV"];

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />

      <MFNavHeader setFilter={setFilter} setIsImportPopupOpen={setIsImportPopupOpen} />
      <MFNavConfig
        tableData={data}
        buttonConfig={buttonConfig}
        loading={loading}
      />
      <ImportSchemePopup
        isOpen={isImportPopupOpen}
        onClose={() => setIsImportPopupOpen(false)}
        url={`import-mf-nav`}
        title="Import MF NAV"
      />
    </div>
  );
};

export default MFNav;
